var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvChargersBooking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.242,
    height: 69.242,
    viewBox: "0 0 69.242 69.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EV_Chargers_Booking",
    "data-name": "EV Chargers Booking",
    transform: "translate(6.973 13.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(-6.973 -13.949)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.242,
    height: 69.242,
    rx: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 66.242,
    height: 66.242,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(4.67 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M27.749,17.564A8.735,8.735,0,1,0,36.483,26.3,8.734,8.734,0,0,0,27.749,17.564Z",
    transform: "translate(9.472 6.31)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M-2404.453-19619.18v-.357h-.893v.357a.536.536,0,0,1-.535.535h-1.428a.537.537,0,0,1-.537-.535v-.371a1.25,1.25,0,0,1-1.07-1.234v-5.715a1.251,1.251,0,0,1,1.249-1.248h4.284a1.245,1.245,0,0,1,1.161.791.508.508,0,0,1,.269-.078h.891a1.661,1.661,0,0,1,1.3.625l.535.672a2.176,2.176,0,0,1,.362.65,2.247,2.247,0,0,1,.123.734v5.174a2.832,2.832,0,0,1-.837,2.02,2.836,2.836,0,0,1-2.019.838A2.86,2.86,0,0,1-2404.453-19619.18Zm.356,0a2.5,2.5,0,0,0,2.5,2.5,2.48,2.48,0,0,0,1.766-.73,2.488,2.488,0,0,0,.734-1.768v-1.783h-.537v1.783a1.942,1.942,0,0,1-.576,1.389,1.948,1.948,0,0,1-1.387.576,1.965,1.965,0,0,1-1.963-1.965v-.357h-.537Zm1.965-1.605a1.25,1.25,0,0,1-1.072,1.234v.371a1.609,1.609,0,0,0,1.607,1.607,1.6,1.6,0,0,0,1.136-.471,1.606,1.606,0,0,0,.47-1.137v-1.811a.709.709,0,0,1-.535-.687v-1.713l-.967-.963h-.463a.585.585,0,0,1-.177-.033Zm-6.427-5.715v5.715a.892.892,0,0,0,.893.891h4.284a.892.892,0,0,0,.893-.891v-5.715a.89.89,0,0,0-.893-.889h-4.284A.89.89,0,0,0-2408.559-19626.5Zm7.5.715a.18.18,0,0,0,.179.18.18.18,0,0,0,.179-.18.179.179,0,0,0-.179-.178A.179.179,0,0,0-2401.062-19625.785Zm-.714,0a.18.18,0,0,0,.179.18.18.18,0,0,0,.179-.18.179.179,0,0,0-.179-.178A.179.179,0,0,0-2401.776-19625.785Zm-5.891,3.213a2.142,2.142,0,0,1,2.142-2.141,2.142,2.142,0,0,1,2.142,2.141,2.144,2.144,0,0,1-2.142,2.145A2.144,2.144,0,0,1-2407.667-19622.572Zm.893,0,1.07.449-.171.975,1.6-1.424-1.072-.445.179-.98Zm3.214-2.855v-1.248a.178.178,0,0,1,.177-.18.179.179,0,0,1,.179.18v1.248a.18.18,0,0,1-.179.18A.179.179,0,0,1-2403.56-19625.428Zm-4.286,0v-1.248a.18.18,0,0,1,.179-.18.179.179,0,0,1,.179.18v1.248a.18.18,0,0,1-.179.18A.181.181,0,0,1-2407.845-19625.428Zm.834.021v-1.123h2.622v1.123Z",
    transform: "translate(2441.218 19655.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M27.2,35.16a11.1,11.1,0,0,1,16.706-9.6V11.248a6.535,6.535,0,0,0-6.535-6.535H33.936V3.981a1.431,1.431,0,0,0-2.862,0v.731H13.948V3.981a1.431,1.431,0,0,0-2.862,0v.731H7.635A6.535,6.535,0,0,0,1.1,11.248V34.687a6.535,6.535,0,0,0,6.535,6.535H29.01A11.05,11.05,0,0,1,27.2,35.16Zm5.593-17.2a1.652,1.652,0,1,1-1.652,1.652A1.652,1.652,0,0,1,32.793,17.965ZM12.221,30.271a1.652,1.652,0,1,1,1.652-1.652A1.652,1.652,0,0,1,12.221,30.271Zm0-9a1.652,1.652,0,1,1,1.652-1.652A1.652,1.652,0,0,1,12.221,21.269Zm10.287,9a1.652,1.652,0,1,1,1.652-1.652A1.652,1.652,0,0,1,22.508,30.271Zm0-9a1.652,1.652,0,1,1,1.652-1.652A1.652,1.652,0,0,1,22.508,21.269Z",
    transform: "translate(-1.1 -2.55)",
    fill: "#00b26b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvChargersBooking);
export default __webpack_public_path__ + "static/media/EVChargersBooking.368843043159236199d2f56ae196858b.svg";
export { ForwardRef as ReactComponent };